var $bc5c688ddc9e69fb$exports = {};
$bc5c688ddc9e69fb$exports = {
    "loading": `Se \xeencarc\u{103}...`,
    "loadingMore": `Se \xeencarc\u{103} mai multe...`
};


export {$bc5c688ddc9e69fb$exports as default};
//# sourceMappingURL=ro-RO.module.js.map
